import React from "react";

export const AffiliationContext = React.createContext<
  | {
      onCreatePayoutClick: () => void;
      hasPayoutMethod?: boolean;
      createOrCopyReferralLink: () => void;
      copyPromoCode: () => void;
      getPromoCodeLoading: boolean;
      getReferralLinkLoading: boolean;
      hasFeatureFlag?: boolean;
      isAdmin?: boolean;
      balance?: number;
    }
  | undefined
>(undefined);
